import { FC, useEffect,MouseEvent } from "react";
import { useMutation } from "react-query";
import { Button, CircularProgress, Paper, TableContainer, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import moment from "moment";

import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent from "../../component/TableComponent";
import { clinicId } from "../../../constants";

import useRepotFile from "../../hooks/reportFileHook";
import { departmentWiseReportSearchService,departmentWiseReportSearchpdfService } from "./service";



const PaymentTypeWiseReport: FC = () => {
  const { control,reset,handleSubmit ,getValues} = useForm();
  const {
    mutate: searchList,
    data: searchData,
    isLoading: searchDataDataLoading,
    reset:resetMutation
  } = useMutation(departmentWiseReportSearchService);
  const {mutate:getPdf,isLoading:pdfLoading}=useRepotFile({apiFunction:departmentWiseReportSearchpdfService})
  const onSubmit = (data:any)=>{
    searchList({...data,clinicId});
  }

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: ""
    });
    resetMutation()
  }

  useEffect(() => {
    searchList({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    })
  }, []);

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
        getPdf({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
        clinicId
      });
    } 
  };

    const onChange = ()=>{
        const data = getValues()
        if(data?.fromDate && data?.toDate){
          searchList({ ...data, clinicId });
        }else{
          resetMutation()
        }
      }

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
              Department Wise Collection Detailed  Report
          </Typography>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-2 gap-3 p-4">
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "To Date is required",onChange}}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
                     <Button
                     disabled={pdfLoading ||searchDataDataLoading|| !Boolean(searchData?.response?.length)}
                     endIcon={pdfLoading && <CircularProgress size={18} />}
                     data-filetype="pdf"
                     onClick={getFiles}
                     >
                     PDF
                     </Button>
        </div>
        <TableComponent
          loading={searchDataDataLoading}
          data={searchData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default PaymentTypeWiseReport;
const heading = [
    { heading: "Doctor Name", key: "docName" },
    { heading: "Department Name", key: "departmentName" },
    { heading: "Amount", key: "amount" }
  ];
  
